import { filter, last, map, pipe, toPairs, find, pathEq, path } from 'ramda';

export const createFhirOrgnaizationObject = ({ email, name, siteId }) => ({
  resourceType: 'Organization',
  id: `${siteId}-organization`,
  name,
  telecom: [{ system: 'email', value: email }],
});

const getMemberObj = (practitioners, id) =>
  pipe(
    find(pathEq(['resource', 'id'], id)),
    practitioner => {
      return {
        display: path(['resource', 'name', '0', 'text'], practitioner),
        identifier: {
          value: path(
            ['resource', 'qualification', '0', 'code', 'coding', '0', 'code'],
            practitioner,
          ),
        },
        reference: `Practitioner/${id}`,
      };
    },
  )(practitioners);

export const createFhirCareTeamObject = ({ name, participants, siteId }, practitioners) => ({
  resourceType: 'CareTeam',
  id: `${siteId}-careteam`,
  status: 'active',
  name,
  participant: pipe(
    toPairs,
    filter(last),
    map(([id]) => ({
      member: getMemberObj(practitioners, id),
    })),
  )(participants),
  managingOrganization: [{ reference: `Organization/${siteId}-organization` }],
});
